import {Layout } from "antd";
import { Component } from "react";


class Footer extends Component {
    constructor(props){
        super(props)
    }

    render(){
        return (
            <>
                <Layout
                    style={{
                        textAlign: 'center',
                    }}
                >
                Copyright 2024 Kai OS Technologies  
                </Layout>
            </>
        )
    }
}


export default Footer;


